import React from 'react'
import CodeEditor from '../components/CodeEditor'

export default function TwigPlayground() {
  return (
    <CodeEditor />
  )
}
